.Label {
  --brand-Label-gradient-radial: radial-gradient(
    circle at top left,
    var(--brand-Label-color-start),
    var(--brand-Label-color-end)
  );

  --brand-Label-gradient-conical: conic-gradient(
    from 90deg at center,
    var(--brand-Label-color-stop-1) 0deg,
    var(--brand-Label-color-stop-2) 160deg,
    var(--brand-Label-color-stop-3) 175deg,
    var(--brand-Label-color-stop-4) 200deg,
    var(--brand-Label-color-stop-4) 350deg,
    var(--brand-Label-color-stop-1) 360deg
  );

  --brand-Label-background: var(
    --brand-Label-gradient-conical,
    var(--brand-Label-gradient-radial, var(--brand-Label-color, currentColor))
  );

  vertical-align: middle;
  align-items: center;
  justify-content: center;
  border-radius: var(--brand-borderRadius-xlarge);
  display: inline-flex;
  color: var(--brand-Label-color-start, var(--brand-Label-color, currentColor));
  position: relative;
  height: min-content;
  background: none;
  text-align: center;
}

[data-color-mode='dark'] .Label {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: auto;
}

@media (prefers-color-scheme: dark) {
  [data-color-mode='auto'] .Label {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: auto;
  }
}

.Label::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: var(--brand-borderWidth-thin);
  border-radius: inherit;
  background: var(--brand-Label-background);
  -webkit-mask: linear-gradient(var(--brand-color-canvas-default), var(--brand-color-canvas-default)) content-box,
    linear-gradient(var(--brand-color-canvas-default), var(--brand-color-canvas-default));
  mask: linear-gradient(var(--brand-color-canvas-default), var(--brand-color-canvas-default)) content-box,
    linear-gradient(var(--brand-color-canvas-default), var(--brand-color-canvas-default));
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}

.Label--size-small {
  min-height: var(--base-size-20);
  padding-inline: var(--base-size-8);
  padding-block: var(--base-size-2);
}

.Label--size-small .Label__label {
  font-size: var(--base-size-12) !important; /* Font size not available in the typographic scale */
}

.Label--size-medium {
  min-height: var(--base-size-28);
  padding-inline: var(--base-size-16);
  padding-block: var(--base-size-4);
}

.Label--size-large {
  min-height: var(--base-size-32);
  padding-inline: var(--base-size-16);
  padding-block: var(--base-size-4);
}

.Label--color-default {
  --brand-Label-color: var(--brand-Label-color-default);
}

.Label--color-blue {
  --brand-Label-color: var(--brand-Label-color-blue);
}

.Label--color-blue-purple {
  --brand-Label-color-start: var(--brand-Label-color-blue-purple-start);
  --brand-Label-color-end: var(--brand-Label-color-blue-purple-end);
}

.Label--color-coral {
  --brand-Label-color: var(--brand-Label-color-coral);
}

.Label--color-green {
  --brand-Label-color: var(--brand-Label-color-green);
}

.Label--color-green-blue {
  --brand-Label-color-start: var(--brand-Label-color-green-blue-start);
  --brand-Label-color-end: var(--brand-Label-color-green-blue-end);
}

.Label--color-gray {
  --brand-Label-color: var(--brand-Label-color-gray);
}

.Label--color-indigo {
  --brand-Label-color: var(--brand-Label-color-indigo);
}

.Label--color-lemon {
  --brand-Label-color: var(--brand-Label-color-lemon);
}

.Label--color-lime {
  --brand-Label-color: var(--brand-Label-color-lime);
}

.Label--color-orange {
  --brand-Label-color: var(--brand-Label-color-orange);
}

.Label--color-pink {
  --brand-Label-color: var(--brand-Label-color-pink);
}

.Label--color-pink-blue {
  --brand-Label-color-start: var(--brand-Label-color-pink-blue-start);
  --brand-Label-color-end: var(--brand-Label-color-pink-blue-end);
}

.Label--color-green-blue-purple {
  --brand-Label-color-stop-1: var(--brand-Label-color-green-blue-purple-1);
  --brand-Label-color-stop-2: var(--brand-Label-color-green-blue-purple-2);
  --brand-Label-color-stop-3: var(--brand-Label-color-green-blue-purple-3);
  --brand-Label-color-stop-4: var(--brand-Label-color-green-blue-purple-4);
}

.Label--color-purple {
  --brand-Label-color: var(--brand-Label-color-purple);
}

.Label--color-purple-red {
  --brand-Label-color-start: var(--brand-Label-color-purple-red-start);
  --brand-Label-color-end: var(--brand-Label-color-purple-red-end);
}

.Label--color-red {
  --brand-Label-color: var(--brand-Label-color-red);
}

.Label--color-red-orange {
  --brand-Label-color-start: var(--brand-Label-color-red-orange-start);
  --brand-Label-color-end: var(--brand-Label-color-red-orange-end);
}

.Label--color-teal {
  --brand-Label-color: var(--brand-Label-color-teal);
}

.Label--color-yellow {
  --brand-Label-color: var(--brand-Label-color-yellow);
}

.Label__text:not(.Label--gradient .Label__text) {
  background: var(--brand-Label-background);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
}

.Label__text {
  line-height: var(--base-size-16);
}

.Label__icon-visual {
  display: flex;
  align-self: center;
  height: var(--base-size-16);
  width: auto;
}

.Label__leading-visual {
  display: flex;
  margin-right: var(--base-size-8);
}

.Label__label {
  font-weight: var(--base-text-weight-medium);
  line-height: inherit;
}

@media (forced-colors: active) {
  .Label {
    outline: var(--brand-borderWidth-thin) solid transparent;
  }
}
